import * as _ from 'lodash';
import { RouterState } from 'react-router';
import * as queryString from 'query-string';

import history from 'login-utils/history';
import * as sessionUtils from 'login-utils/sessionUtils';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import { diagnostics } from 'ui-common/index';

export function personalLoanTypeOnEnter(nextState: RouterState) {
  const { supportedLoanTypes } = deploymentConfig.get();
  if (!_.includes(supportedLoanTypes, 'PERSONAL_LOAN') || !_.includes(supportedLoanTypes, 'PERSONAL_LOC')) {
    const nextURL = nextState.location.pathname;
    diagnostics.breadcrumb(
      `Not going to ${nextURL} because neither loan types PERSONAL_LOAN nor PERSONAL_LOC are enabled.`,
    );
    return history.goBack();
  }

  const query = queryString.parse(nextState.location.search);
  sessionUtils.saveQueryToSession(query);
}
